 export const  ProcessStatus ={
    Pending : 0,
    InProgress : 1,
    Done: 2,
};
export const CountryType = {
    All: '--All--',
    AllOverseasUser: '--All Overseas Users--'
};

export const ValidInputLength = {
    MAX_USERNAME_LENGTH : 120,
    MAX_PASSWORD_LENGTH : 120
}

export const ConfigurationVariable = {
    Automation: 'Automation',
    Debug: 'Debug',
    Release: 'Release'
};

export const TurnstileErrors = {
    TurnstileErrorInfo: 'Error while generating token for turnstile',
    TurnstileErrorMessageForUnsupportedBrowser: 'Browser not supported with no error code',
    TurnstileErrorForUnsupportedBrowser: 'Turnstile not supported, Please try on upgraded browsers.',
    DefaultTurnstileRetryCount: 2
};

export const TurnstileStatus = {
    UP: true,
    DOWN: false
};

// Common category-based max lengths used across forms
export const MaxLengthForInput = {
    NAME: 50,
    ADDRESS: 600,
    PHONE: 20,
    DESC: 1000
};